export * from './show.component';
